// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.community_slider_main_div {
  padding: 0 50px;
  background: #161616;
  padding: 91px 77px 67px 77px;
  position: relative;
}

.community_slider_main_heading {
  color: #ba1e24;
  font-family: Thicker;
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: 126.6%;
  text-align: center;
}

.community_slider_comma_img_div {
  position: absolute;
  z-index: 0;
  margin-top: -80px;
}

.community_slider_comma_img_div > img {
  width: 170px;
  height: 162px;
}

.community_slider_main_title {
  color: #fff;
  font-family: Thicker;
  font-size: 26px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  margin-top: 10px;
}

.community_slider_top_img_div {
  width: 100%;
  margin-top: 20px;
  /* height: 602px; */
}

.community_slider_video {
  width: 100%;
  border-radius: 12px;
  /* height: 602px; */
  object-fit: cover;
}

.community_slider_btns_div {
  width: 100%;
  /* padding-left: 80px; */
  margin-top: 46px;
  margin-bottom: 76px;
  padding: 0 50px;
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
}

.community_slider_thumbnail_div {
  width: calc(33% - 6px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 10px 0;
}

.community_slider_thumbnail_div_img {
  width: calc(100% - 20px) !important;
  height: 237px !important;
  object-fit: cover;
  /* border-radius: 12px; */
  margin: 0 10px !important;
  cursor: pointer;
  /* position: absolute; */
  z-index: 1;
}

.community_slider_thumbnail_div > p {
  position: absolute;
  z-index: 2;
  margin-top: -100px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  cursor: pointer;
}

.community_play_btn {
  background-color: white;
  border-radius: 50%;
  width: 50px;
}

.community_second_slide_div {
  width: 100%;
  position: relative;
}

.community_slider_arrow_left_div {
  width: 50px;
  position: absolute;
  z-index: 2;
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* overflow: hidden; */
  padding: 0 10px;
}

.community_slider_arrow_left_div > button {
  background-color: rgb(214, 213, 213);
  border-radius: 50%;
  border: none;
  padding: 8px 12px;
  color: black;
  cursor: pointer;
  height: 45px;
    width: 45px;
}

.community_slider_arrow_right_div {
  width: 50px;
  position: absolute;
  z-index: 1;
  right: 0;
  margin-top: -180px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* overflow: hidden; */
  padding: 0 10px;
  
}

.community_slider_arrow_right_div > button {
  background-color: rgb(214, 213, 213);
  border-radius: 50%;
  border: none;
  padding: 8px 12px;
  color: black;
  cursor: pointer;
  height: 45px;
    width: 45px;
}












@media screen and (max-width: 1200px) {

    .community_slider_main_div {
        padding: 0 30px;
        padding: 40px 50px 40px 50px;
      }
      
      .community_slider_main_heading {
        font-size: 32px;
        line-height: 30px;
      }
      
      .community_slider_comma_img_div {
        margin-top: -80px;
      }
      
      .community_slider_comma_img_div > img {
        width: 170px;
        height: 162px;
      }
      
      .community_slider_main_title {
        font-size: 20px;
      }
      
      .community_slider_video {
        border-radius: 12px;
      }
      
      .community_slider_btns_div {
        margin-top: 46px;
        margin-bottom: 76px;
        padding: 0 50px;
        gap: 4px;
      }
      
      .community_slider_thumbnail_div {
        width: calc(50% - 4px);
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        margin: 10px 0;
      }

      .community_slider_thumbnail_div_img {
        width: calc(100% - 20px) !important;
        /* height: 173px !important; */
        margin: 0 10px !important;
      }
      
      .community_slider_arrow_btns_div {
        margin-top: -180px;
        padding: 0 10px;
      }
      
      .community_slider_arrow_btns_div > button {
        padding: 8px 12px;
      }

}













@media screen and (max-width: 800px) {

    .community_slider_main_div {
        padding: 0 30px;
        padding: 40px 30px 0px 30px;
      }
      
      .community_slider_main_heading {
        font-size: 32px;
        line-height: 30px;
      }
      
      .community_slider_comma_img_div {
        margin-top: -60px;
      }
      
      .community_slider_comma_img_div > img {
        width: 170px;
        height: 162px;
      }
      
      .community_slider_main_title {
        font-size: 20px;
      }
      
      .community_slider_video {
        border-radius: 12px;
      }
      
      .community_slider_btns_div {
        margin-top: 46px;
        margin-bottom: 76px;
        padding: 0 50px;
      }
      
      .community_slider_thumbnail_div_img {
        width: calc(100% - 10px) !important;
        height: 173px !important;
        margin: 0 5px !important;
      }
      
      .community_slider_arrow_btns_div {
        margin-top: -180px;
        padding: 0 10px;
      }
      
      .community_slider_arrow_btns_div > button {
        padding: 8px 12px;
      }

}












@media screen and (max-width: 600px) {

  .community_slider_top_img_div {
    width: 100%;
    margin-top: 0px;
    /* height: 602px; */
  }

    .community_slider_main_div {
        padding: 0px;
        padding: 20px 20px 0px 20px;
      }
      
      .community_slider_main_heading {
        font-size: 26px;
        line-height: 28px;
      }
      
      .community_slider_comma_img_div {
        margin-top: -40px;
        width: 60px !important;
        height: 60px;
      }
      
      .community_slider_comma_img_div > img {
        width: 60px !important;
        height: 60px;
      }
      
      .community_slider_main_title {
        font-size: 16px;
        line-height: 22px;
      }
      
      .community_slider_video {
        border-radius: 12px;
        height: 300px;
      }
      
      .community_slider_btns_div {
        margin-top: 10px;
        margin-bottom: 10px;
        padding: 25px;
      }
      
      .community_slider_thumbnail_div_img {
        width: calc(100% - 20px) !important;
        min-height: 100px !important; /* Ensuring minimum height of 200px */
        margin: 0 10px !important;
        object-fit: cover;
      }


.community_slider_thumbnail_div > p {
  margin-top: -65px;
  font-size: 30px;
}
      
.community_slider_arrow_left_div {
  width: 30px;
  margin-top: 50px;
  padding: 0 4px;
}

.community_slider_arrow_left_div > button {
  padding: 3px 6px;
}

.community_slider_arrow_right_div {
  margin-top: -120px;
  padding: 0 4px;
}

.community_slider_arrow_right_div > button {
  padding: 3px 6px;
}

}












@media screen and (max-width: 450px) {
  

    .community_slider_main_div {
        padding: 0px;
        padding: 20px 20px 0px 20px;
      }
      
      .community_slider_main_heading {
        font-size: 24px;
        line-height: 28px;
      }
      
      .community_slider_comma_img_div {
        margin-top: -40px;
      }
      
      .community_slider_video {
        border-radius: 12px;
        height: 270px !important;
      }
      
      .community_slider_btns_div {
        margin-top: 20px;
        /* margin-bottom: 0px; */
        padding: 0 16px;
      }

      .community_slider_thumbnail_div {
        width: 100%;
        margin: 10px 0;
      }
      
      .community_slider_thumbnail_div_img {
        width: 100% !important;
        height: 173px !important;
        margin: 0 !important;
      }
    
            
.community_slider_arrow_left_div {
  width: 30px;
  margin-top: 40px;
  padding: 0 4px;
}

.community_slider_arrow_left_div > button {
  padding: 3px 6px;
}

.community_slider_arrow_right_div {
  margin-top: -100px;
  padding: 0 4px;
}

.community_slider_arrow_right_div > button {
  padding: 3px 6px;
}

.community_second_slide_div {
  height: 300px;
  overflow: scroll;
}

}`, "",{"version":3,"sources":["webpack://./src/components/community/communitySlider.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,YAAY;IACV,WAAW;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;;AAEjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,YAAY;IACV,WAAW;AACf;;;;;;;;;;;;;AAaA;;IAEI;QACI,eAAe;QACf,4BAA4B;MAC9B;;MAEA;QACE,eAAe;QACf,iBAAiB;MACnB;;MAEA;QACE,iBAAiB;MACnB;;MAEA;QACE,YAAY;QACZ,aAAa;MACf;;MAEA;QACE,eAAe;MACjB;;MAEA;QACE,mBAAmB;MACrB;;MAEA;QACE,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;QACf,QAAQ;MACV;;MAEA;QACE,sBAAsB;QACtB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,kBAAkB;QAClB,cAAc;MAChB;;MAEA;QACE,mCAAmC;QACnC,8BAA8B;QAC9B,yBAAyB;MAC3B;;MAEA;QACE,kBAAkB;QAClB,eAAe;MACjB;;MAEA;QACE,iBAAiB;MACnB;;AAEN;;;;;;;;;;;;;;AAcA;;IAEI;QACI,eAAe;QACf,2BAA2B;MAC7B;;MAEA;QACE,eAAe;QACf,iBAAiB;MACnB;;MAEA;QACE,iBAAiB;MACnB;;MAEA;QACE,YAAY;QACZ,aAAa;MACf;;MAEA;QACE,eAAe;MACjB;;MAEA;QACE,mBAAmB;MACrB;;MAEA;QACE,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;MACjB;;MAEA;QACE,mCAAmC;QACnC,wBAAwB;QACxB,wBAAwB;MAC1B;;MAEA;QACE,kBAAkB;QAClB,eAAe;MACjB;;MAEA;QACE,iBAAiB;MACnB;;AAEN;;;;;;;;;;;;;AAaA;;EAEE;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;;IAEE;QACI,YAAY;QACZ,2BAA2B;MAC7B;;MAEA;QACE,eAAe;QACf,iBAAiB;MACnB;;MAEA;QACE,iBAAiB;QACjB,sBAAsB;QACtB,YAAY;MACd;;MAEA;QACE,sBAAsB;QACtB,YAAY;MACd;;MAEA;QACE,eAAe;QACf,iBAAiB;MACnB;;MAEA;QACE,mBAAmB;QACnB,aAAa;MACf;;MAEA;QACE,gBAAgB;QAChB,mBAAmB;QACnB,aAAa;MACf;;MAEA;QACE,mCAAmC;QACnC,4BAA4B,EAAE,qCAAqC;QACnE,yBAAyB;QACzB,iBAAiB;MACnB;;;AAGN;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;AAaA;;;IAGI;QACI,YAAY;QACZ,2BAA2B;MAC7B;;MAEA;QACE,eAAe;QACf,iBAAiB;MACnB;;MAEA;QACE,iBAAiB;MACnB;;MAEA;QACE,mBAAmB;QACnB,wBAAwB;MAC1B;;MAEA;QACE,gBAAgB;QAChB,wBAAwB;QACxB,eAAe;MACjB;;MAEA;QACE,WAAW;QACX,cAAc;MAChB;;MAEA;QACE,sBAAsB;QACtB,wBAAwB;QACxB,oBAAoB;MACtB;;;AAGN;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA","sourcesContent":[".community_slider_main_div {\n  padding: 0 50px;\n  background: #161616;\n  padding: 91px 77px 67px 77px;\n  position: relative;\n}\n\n.community_slider_main_heading {\n  color: #ba1e24;\n  font-family: Thicker;\n  font-size: 36px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 126.6%;\n  text-align: center;\n}\n\n.community_slider_comma_img_div {\n  position: absolute;\n  z-index: 0;\n  margin-top: -80px;\n}\n\n.community_slider_comma_img_div > img {\n  width: 170px;\n  height: 162px;\n}\n\n.community_slider_main_title {\n  color: #fff;\n  font-family: Thicker;\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 150%;\n  margin-top: 10px;\n}\n\n.community_slider_top_img_div {\n  width: 100%;\n  margin-top: 20px;\n  /* height: 602px; */\n}\n\n.community_slider_video {\n  width: 100%;\n  border-radius: 12px;\n  /* height: 602px; */\n  object-fit: cover;\n}\n\n.community_slider_btns_div {\n  width: 100%;\n  /* padding-left: 80px; */\n  margin-top: 46px;\n  margin-bottom: 76px;\n  padding: 0 50px;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.community_slider_thumbnail_div {\n  width: calc(33% - 6px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin: 10px 0;\n}\n\n.community_slider_thumbnail_div_img {\n  width: calc(100% - 20px) !important;\n  height: 237px !important;\n  object-fit: cover;\n  /* border-radius: 12px; */\n  margin: 0 10px !important;\n  cursor: pointer;\n  /* position: absolute; */\n  z-index: 1;\n}\n\n.community_slider_thumbnail_div > p {\n  position: absolute;\n  z-index: 2;\n  margin-top: -100px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 40px;\n  cursor: pointer;\n}\n\n.community_play_btn {\n  background-color: white;\n  border-radius: 50%;\n  width: 50px;\n}\n\n.community_second_slide_div {\n  width: 100%;\n  position: relative;\n}\n\n.community_slider_arrow_left_div {\n  width: 50px;\n  position: absolute;\n  z-index: 2;\n  margin-top: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  /* overflow: hidden; */\n  padding: 0 10px;\n}\n\n.community_slider_arrow_left_div > button {\n  background-color: rgb(214, 213, 213);\n  border-radius: 50%;\n  border: none;\n  padding: 8px 12px;\n  color: black;\n  cursor: pointer;\n  height: 45px;\n    width: 45px;\n}\n\n.community_slider_arrow_right_div {\n  width: 50px;\n  position: absolute;\n  z-index: 1;\n  right: 0;\n  margin-top: -180px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  /* overflow: hidden; */\n  padding: 0 10px;\n  \n}\n\n.community_slider_arrow_right_div > button {\n  background-color: rgb(214, 213, 213);\n  border-radius: 50%;\n  border: none;\n  padding: 8px 12px;\n  color: black;\n  cursor: pointer;\n  height: 45px;\n    width: 45px;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1200px) {\n\n    .community_slider_main_div {\n        padding: 0 30px;\n        padding: 40px 50px 40px 50px;\n      }\n      \n      .community_slider_main_heading {\n        font-size: 32px;\n        line-height: 30px;\n      }\n      \n      .community_slider_comma_img_div {\n        margin-top: -80px;\n      }\n      \n      .community_slider_comma_img_div > img {\n        width: 170px;\n        height: 162px;\n      }\n      \n      .community_slider_main_title {\n        font-size: 20px;\n      }\n      \n      .community_slider_video {\n        border-radius: 12px;\n      }\n      \n      .community_slider_btns_div {\n        margin-top: 46px;\n        margin-bottom: 76px;\n        padding: 0 50px;\n        gap: 4px;\n      }\n      \n      .community_slider_thumbnail_div {\n        width: calc(50% - 4px);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        position: relative;\n        margin: 10px 0;\n      }\n\n      .community_slider_thumbnail_div_img {\n        width: calc(100% - 20px) !important;\n        /* height: 173px !important; */\n        margin: 0 10px !important;\n      }\n      \n      .community_slider_arrow_btns_div {\n        margin-top: -180px;\n        padding: 0 10px;\n      }\n      \n      .community_slider_arrow_btns_div > button {\n        padding: 8px 12px;\n      }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 800px) {\n\n    .community_slider_main_div {\n        padding: 0 30px;\n        padding: 40px 30px 0px 30px;\n      }\n      \n      .community_slider_main_heading {\n        font-size: 32px;\n        line-height: 30px;\n      }\n      \n      .community_slider_comma_img_div {\n        margin-top: -60px;\n      }\n      \n      .community_slider_comma_img_div > img {\n        width: 170px;\n        height: 162px;\n      }\n      \n      .community_slider_main_title {\n        font-size: 20px;\n      }\n      \n      .community_slider_video {\n        border-radius: 12px;\n      }\n      \n      .community_slider_btns_div {\n        margin-top: 46px;\n        margin-bottom: 76px;\n        padding: 0 50px;\n      }\n      \n      .community_slider_thumbnail_div_img {\n        width: calc(100% - 10px) !important;\n        height: 173px !important;\n        margin: 0 5px !important;\n      }\n      \n      .community_slider_arrow_btns_div {\n        margin-top: -180px;\n        padding: 0 10px;\n      }\n      \n      .community_slider_arrow_btns_div > button {\n        padding: 8px 12px;\n      }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 600px) {\n\n  .community_slider_top_img_div {\n    width: 100%;\n    margin-top: 0px;\n    /* height: 602px; */\n  }\n\n    .community_slider_main_div {\n        padding: 0px;\n        padding: 20px 20px 0px 20px;\n      }\n      \n      .community_slider_main_heading {\n        font-size: 26px;\n        line-height: 28px;\n      }\n      \n      .community_slider_comma_img_div {\n        margin-top: -40px;\n        width: 60px !important;\n        height: 60px;\n      }\n      \n      .community_slider_comma_img_div > img {\n        width: 60px !important;\n        height: 60px;\n      }\n      \n      .community_slider_main_title {\n        font-size: 16px;\n        line-height: 22px;\n      }\n      \n      .community_slider_video {\n        border-radius: 12px;\n        height: 300px;\n      }\n      \n      .community_slider_btns_div {\n        margin-top: 10px;\n        margin-bottom: 10px;\n        padding: 25px;\n      }\n      \n      .community_slider_thumbnail_div_img {\n        width: calc(100% - 20px) !important;\n        min-height: 100px !important; /* Ensuring minimum height of 200px */\n        margin: 0 10px !important;\n        object-fit: cover;\n      }\n\n\n.community_slider_thumbnail_div > p {\n  margin-top: -65px;\n  font-size: 30px;\n}\n      \n.community_slider_arrow_left_div {\n  width: 30px;\n  margin-top: 50px;\n  padding: 0 4px;\n}\n\n.community_slider_arrow_left_div > button {\n  padding: 3px 6px;\n}\n\n.community_slider_arrow_right_div {\n  margin-top: -120px;\n  padding: 0 4px;\n}\n\n.community_slider_arrow_right_div > button {\n  padding: 3px 6px;\n}\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 450px) {\n  \n\n    .community_slider_main_div {\n        padding: 0px;\n        padding: 20px 20px 0px 20px;\n      }\n      \n      .community_slider_main_heading {\n        font-size: 24px;\n        line-height: 28px;\n      }\n      \n      .community_slider_comma_img_div {\n        margin-top: -40px;\n      }\n      \n      .community_slider_video {\n        border-radius: 12px;\n        height: 270px !important;\n      }\n      \n      .community_slider_btns_div {\n        margin-top: 20px;\n        /* margin-bottom: 0px; */\n        padding: 0 16px;\n      }\n\n      .community_slider_thumbnail_div {\n        width: 100%;\n        margin: 10px 0;\n      }\n      \n      .community_slider_thumbnail_div_img {\n        width: 100% !important;\n        height: 173px !important;\n        margin: 0 !important;\n      }\n    \n            \n.community_slider_arrow_left_div {\n  width: 30px;\n  margin-top: 40px;\n  padding: 0 4px;\n}\n\n.community_slider_arrow_left_div > button {\n  padding: 3px 6px;\n}\n\n.community_slider_arrow_right_div {\n  margin-top: -100px;\n  padding: 0 4px;\n}\n\n.community_slider_arrow_right_div > button {\n  padding: 3px 6px;\n}\n\n.community_second_slide_div {\n  height: 300px;\n  overflow: scroll;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
